import { createSlice } from '@reduxjs/toolkit';
import {
  PackageDataInterface,
  DynamicPackageDataInterface,
  CheapestFlightInterface,
  packageFormattedDataInterface,
} from './packageDataInterface';

const initialState: {
  packageData: PackageDataInterface;
  dynamicPackageData: DynamicPackageDataInterface;
  cheapestFlight: CheapestFlightInterface;
  packageFormattedData: packageFormattedDataInterface;
} = {
  packageData: {} as PackageDataInterface,
  dynamicPackageData: {} as DynamicPackageDataInterface,
  cheapestFlight: {} as CheapestFlightInterface,
  packageFormattedData: {} as packageFormattedDataInterface,
};

export const searchSlice = createSlice({
  name: 'packageData',
  initialState,
  reducers: {
    updatePackageData: (state, action) => {
      state.packageData = action.payload;
    },
    updateDynamicPackageData: (state, action) => {
      state.dynamicPackageData = action.payload;
    },
    updateCheapestFlight: (state, action) => {
      state.cheapestFlight = action.payload;
    },
    updateFormattedData: (state, action) => {
      state.packageFormattedData = action.payload;
    },
  },
});

export const {
  updatePackageData,
  updateDynamicPackageData,
  updateCheapestFlight,
  updateFormattedData,
} = searchSlice.actions;

export default searchSlice.reducer;
